import { useState, useEffect, useMemo } from "react";
import { Loading } from "../Components/Loading/Loading";
import { EngineerWorkloadChart } from "../Components/Workload/EngineerWorkloadChart";
import { LatestTickets } from "../Components/Home/LatestTickets";
import { redirectToLogin } from "../utils/auth";
import { useUser } from "../context/UserContext";

const API = process.env.REACT_APP_BACKEND_URL;

export const Workload = () => {
  const [tickets, setTickets] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [requestOptions, setRequestOptions] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [loading, setLoading] = useState(true);
  const authToken = localStorage.getItem("authToken");

  const { user } = useUser();
  const username = user.username;

  useEffect(() => {
    if (!authToken) {
      redirectToLogin();
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    };
    const get = (url) =>
      fetch(url, { method: "GET", headers }).then((r) => {
        if (r.status === 401) {
          redirectToLogin();
          return null;
        }
        return r.json();
      });

    Promise.all([
      get(`${API}/API/V2/Tickets`),              // tickets
      get(`${API}/API/V2/config/priorities`),     // priorities
      get(`${API}/API/V2/config/requesttypes`),   // requestOptions
      get(`${API}/API/V2/config/status`),         // statuses
    ])
      .then(([ticketData, prioritiesData, requestTypesData, statusData]) => {
        if (Array.isArray(ticketData)) {
          setTickets(ticketData);
          setPriorities(prioritiesData || []);
          setRequestOptions(requestTypesData || []);
          setStatuses(statusData || []);
        }
        setLoading(false);
      })
      .catch((err) => console.error("Fetch error:", err));
  }, [authToken]);

  const projects = useMemo(
    () => [...new Set(tickets.map((t) => t.org).filter(Boolean))].sort(),
    [tickets]
  );

  if (loading) return <Loading />;

  return (
    <div className="p-2 rounded-3xl mx-6 mt-2 flex flex-col gap-1">
      <LatestTickets
        tickets={tickets}
        username={username}
        access={3}
        priorities={priorities}
        statuses={statuses}
      />
      <EngineerWorkloadChart
        tickets={tickets}
        projects={projects}
        priorities={priorities}
        requestOptions={requestOptions}
        statuses={statuses}
      />
    </div>
  );
};
